export default __webpack_public_path__ + "static/media/joe_girard.acbb147a.jpeg";